import { Button, Card, Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/system';
import './Indicator.css';
import React, { useEffect, useState } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Inds from '../../../src/Indicators.json';
import Inds2 from './Indicator2.json';
import { Tab, Tabs } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from 'uuid';
import { INDICATORS_REQUEST, INDICATORS_SUCCESS, INDICATORS_FAILURE } from '../../Constants/ActionTypes';
import { toast } from 'react-toastify';
import * as API from '../../API/api.js';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



export const Indicators = () => {
  const userData = JSON.parse(localStorage.getItem('access_token'));

  const [forceRerender, setForceRerender] = useState(true);
  const dispatch = useDispatch();
  const fetchIndicatorData = (token) => async dispatch => {
    try {
      dispatch({ type: INDICATORS_REQUEST });
      const { data } = await API.getIndicators(token);
      if (data) {
        dispatch({ type: INDICATORS_SUCCESS, payload: data });
        setUwpGoals(data);
        console.log(data, '68')
      }
    } catch (error) {
      toast('ERROR IN FETCHING INDICATORS');
      console.log(error);
      dispatch({ type: INDICATORS_FAILURE });
    }
  };

  useEffect(() => {
    axios
      .get(`${API.BASE_URL}/admin/getIndicator`)
      .then(response => {
        setUwpGoals(response.data.data);
        // console.log(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);


  // const [name, setName] = React.useState();

  const [state, setState] = useState([]);
  const [goal, setGoal] = useState('');
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [uwpGoals, setUwpGoals] = useState([])

  // state = [code, goal, type, desc, ind];

  const [open, setOpen] = useState(false);
  const [indData, setIndData] = useState([]);
  const [scroll, setScroll] = useState('paper');
  const [content, setContent] = useState(Inds);
  const handleOpen = indicator => {
    setOpen(true);
    console.log('indicator', indData);
    setContent(indicator);
    setIndData(indicator);
  };

  const submitHandler = e => {
    e.preventDefault();
    const userData = {
      code: uuidv4(),
      type: 'uwp',
      goal: goal,
      description: desc,
      title: title
    }
    window.location = "/admin-dashboard-3"
    axios
      .post(`${API.BASE_URL}/admin/uploadIndicator`, userData)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const goalChange = event => {
    setGoal(event.target.value);
  };
  const descChange = event => {
    setDesc(event.target.value);
  };
  const titleChange = event => {
    setTitle(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
    console.log(uwpGoals);
  };
  console.log(uwpGoals, 'uwpGoals');
  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <>
      <div>
        <Box>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab fontSize="2px" label="UWP Indicators" {...a11yProps(0)} />
            <Tab label="SDG Indicators" {...a11yProps(1)} />
            <Tab label="ADD UWP Indicators" {...a11yProps(2)} />
          </Tabs>
        </Box>

        <Box mx={{ xxs: -8, sm: -5, md: 0, lg: 0, xl: 0 }} sx={{ display: 'flex', flexGrow: 1, my: 2 }}>
          <TabPanel value={value} index={0}>
            <Grid
              direction="row"
              justifyContent="center"
              container
              mx={{ xxs: -2, sm: -13, md: -20.7, lg: -18 }}
              px={{ xs: 19 }}
              spacing={{ xxs: 2, xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
            >
              {uwpGoals.map((indicator, idx) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={idx + 1}>
                  <Card
                    width={{ sm: 4, md: 5, lg: 12 }}
                    sx={{
                      height: 'fillContent',
                      display: 'flex',
                      flexDirection: 'column',
                      p: 2,
                    }}
                    elevation="0"
                  >
                    <Typography sx={{ fontFamily: 'Sora', color: '#FF7345' }}>Goal {indicator.goal}</Typography>
                    {/* <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5 }}>
                      Code {indicator.code}
                    </Typography> */}
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6 }}>
                      {indicator.title} {indicator.description}
                    </Typography>
                    {/* <Button
                      sx={{
                        fontFamily: 'Sora',
                        color: '#FF7345',
                        display: 'flex',
                        justifyContent: 'left',
                        width: '100%',
                        marginTop: '20px',
                      }}
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => handleOpen(indicator)}
                    >
                      Learn More
                    </Button> */}
                  </Card>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid
              direction="row"
              justifyContent="center"
              container
              mx={{ xxs: -2, sm: -13, md: -20.7, lg: -18 }}
              px={{ xs: 19 }}
              spacing={{ xxs: 2, xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
            >
              {Inds2.map((indicator, idx) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={idx + 1}>
                  <Card
                    width={{ sm: 4, md: 5, lg: 12 }}
                    sx={{
                      height: 'fillContent',
                      display: 'flex',
                      flexDirection: 'column',
                      p: 2,
                    }}
                  >
                    <Typography sx={{ fontFamily: 'Sora', color: '#FF7345' }}>Goal {indicator.goal}</Typography>
                    {/* <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5 }}>
                      Code {indicator.code}
                    </Typography> */}
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6 }}>
                      {indicator.title} {indicator.description}
                    </Typography>
                    <Button
                      sx={{
                        fontFamily: 'Sora',
                        color: '#FF7345',
                        display: 'flex',
                        justifyContent: 'left',
                        width: '100%',
                        marginTop: '20px',
                      }}
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => handleOpen(indicator)}
                    >
                      Learn More
                    </Button>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box
              component="form"
              marginLeft={{ xxs: '10vw', sm: '0vw' }}
              sx={{
                '& > :not(style)': { m: 1 },

                width: '90vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              px={12}
              noValidate
            >
              <FormControl sx={{ minWidth: '20vw', width: '30vw' }} variant="standard">
                {/* <TextField
                  style={{ marginTop: '20px' }}
                  id="outlined-helperText"
                  label="Code"
                  value={code}
                  // onChange={handleChangeDuration}
                  variant="outlined"
                /> */}
                <TextField
                  style={{ marginTop: '20px' }}
                  id="outlined-helperText"
                  label="Goal"
                  value={goal}
                  onChange={goalChange}
                  variant="outlined"
                />
                <TextField
                  style={{ marginTop: '20px' }}
                  id="outlined-helperText"
                  label="Title"
                  value={title}
                  onChange={titleChange}
                  variant="outlined"
                />
                <TextField
                  style={{ marginTop: '20px' }}
                  id="outlined-helperText"
                  label="Description"
                  value={desc}
                  onChange={descChange}
                  variant="outlined"
                />
                {/* <TextField
                  style={{ marginTop: '20px' }}
                  id="outlined-helperText"
                  label="Indicators"
                  value={ind}
                  // onChange={setInd('hello')}
                  variant="outlined"
                /> */}
                <div style={{ margin: 'auto', marginTop: '20px' }}>
                  <button type="submit" class="btn btn-success" onClick={submitHandler}>
                    SUBMIT
                  </button>
                </div>
              </FormControl>
            </Box>
          </TabPanel>
        </Box>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" sx={{ fontFamily: 'Sora', color: '#FF7345' }}>
          Goal {content.goal}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <Typography sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', my: 0.5 }}>
              Code {content.code}
            </Typography>
            <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
              {content.code} {content.title}
            </Typography>
            <Typography sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', marginBottom: 1, marginTop: 1 }}>
              Indicators
            </Typography>
            {/* {indData.map(data => (
              <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
                {data.code} {data.description}
              </Typography>
            ))} */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              fontFamily: 'Sora',
              color: '#FF7345',
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
